/*-----------------------------------------------------------------------------/
/--- Age Gate JS Libraries created from scratch by Viseo Shopify Developers ---/
/--- If you doesn't know what's really going on here please don't modify ------/
/--- Created Date: June 18, 2021 || Last Update: July 6, 2021 -----------------/
/-----------------------------------------------------------------------------*/
(function($,w,d,popup,age_confirmation,age_confirmation_country_by_age) {
  var birtdate_section = d.querySelector("#birtdate-section");
  var ageform = d.querySelector(".popup-age-gate");
  var age_inputs = d.querySelectorAll('.popup-age-confirmation .popup-age-gate .birthdate_details > input');
  var age_confirmation_title = d.querySelector('.age-confirmation-title');
  var mistake_button = d.querySelector('.popup-age-gate .btn-age-verification-div');
  var lang_choice_popup = d.querySelector('.language-choice');
  var age_confirmation_popup = d.querySelector('.popup-age-confirmation');
  var selected_country;
  var age_gate_rules_message = d.querySelector(".rte.age-confirmation-content-1");
  var age_gate_footer = d.querySelector(".popup-footer-bar.rte p");
  var today = new Date();
  const ageLimitsByCountry = {
    "fr": 18,
    "be": 18,
    "uk": 18,
    "us": 21,
    "ca": 18,
    "jp": 20,
    "cn": 18,
    "tw": 18,
    "hk": 18,
    "sg": 18,
    "it": 18
  }

  var site_url = {
    "dev_fr" : "https://dev-champagne-telmont-fr.myshopify.com/",
    "dev_uk" : "https://uk-dev-champagne-telmont.myshopify.com/",
    "dev_us" : "https://us-dev-champagne-telmont.myshopify.com/",
    "dev_jp" : "https://jp-dev-champagne-telmont.myshopify.com/",
    "stg_fr" : "https://telmont-staging-fr.myshopify.com/",
    "stg_uk" : "https://telmont-staging-uk.myshopify.com/",
    "stg_us" : "https://telmont-staging-us.myshopify.com/",
    "stg_jp" : "https://telmont-staging-japan.myshopify.com/",
    "live_fr" : "https://fr.champagne-telmont.com/",
    "live_uk" : "https://uk.champagne-telmont.com/",
    "live_us" : "https://us.champagne-telmont.com/",
    "live_jp" : "https://jp.champagne-telmont.com/"
  }

/* start get & set cookies here */
 let cf = {
  setCookie: function (cname, cvalue, exdays, domain = null) {
    var dt = new Date();
    dt.setTime(dt.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + dt.toUTCString();
    var cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    if(domain != null){
      var global_cookie = cookie+";domain="+domain;
      d.cookie = global_cookie;
    }
    else{
      d.cookie = cookie;
    }
  },
  getCookie: function (cname) {
    var name = cname + "=";
    var ca = d.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "on";
  }
}
/* end get & set cookies here */

/* start get url params */  
let uf = {
  getUrlValueByName: function (name) {
    const queryString = window.location.search; 
    const urlParams = new URLSearchParams(queryString); 
    const value = urlParams.get(name); 
    return value;
  }
}
/* end get url params */

popup = d.querySelector(".js-popup");

if (popup && cf.getCookie("age_confirmation") === "on"){
  popup.classList.remove("d-none");
  popup.classList.add("hide-age-gate");
}

age_confirmation = d.querySelector('[data-js-popup-name="age-confirmation"]');
   // excluding the age gate from loading on the customizer (infinite loading of the age gate), YI
   if(window.location.href.includes("privacy-policy")) {
    asyncawaitcookiesconsent(true);
  } else if(uf.getUrlValueByName('by_pass') == '1' || Shopify.designMode){
    cf.setCookie("age_confirmation", "off", 395);
    cf.setCookie("customer_age", 30, 395);
    // excluding the OneTrust banner from loading on the customizer (infinite loading of the coockie banner), YI
    if(!Shopify.designMode){
      asyncawaitcookiesconsent();
    }
  }
else{
  $(d).ready(function() {
    if(cf.getCookie("customer_age") >= ageLimitsByCountry.it){
      asyncawaitcookiesconsent();
      if (popup && cf.getCookie("age_confirmation") === "on") {
        setTimeout( () => {
          popup.classList.add("show-age-gate");
        }, 1000);
        d.body.classList.add("popup-overflow-hidden");
        //console.log("zone C");
      }
      if (cf.getCookie("age_confirmation") === "off") {
        d.body.classList.remove("popup-overflow-hidden");
      }
      if (age_confirmation && cf.getCookie("age_confirmation") === "on") {
        age_confirmation.classList.add("show");
        age_confirmation.classList.add("visible");
        dataLayer.push({
          event: "age_gate_display"
        });
      }
    }
    else{
      asyncawaitcookiesconsent();
      setTimeout( () => {
        popup.classList.remove("d-none");
        popup.classList.add("show-age-gate");
        dataLayer.push({
          event: "age_gate_display"
        });
      }, 1000);
      d.body.classList.add("popup-overflow-hidden");
      age_confirmation.classList.remove("d-none");
      age_confirmation.classList.add("show");
      age_confirmation.classList.add("visible");
    }
    
  });
}

$(d).on('click','#mistake_button', function(){
  var data_store = ageform.getAttribute("data-store");
    age_confirmation_title.textContent = age_confirmation_title.getAttribute('data-year-text');
    mistake_button.classList.add('d-none');
    birtdate_section.classList.remove('d-none');
    age_inputs[2].classList.remove('d-none');
    if(data_store != "US"){
      age_inputs[0].classList.add('d-none');
      age_inputs[1].classList.add('d-none');
      age_inputs[2].focus();
    }
    else{
      age_inputs[1].classList.remove('d-none');
      age_inputs[0].classList.remove('d-none');
      age_inputs[0].focus();
    }
    age_inputs[0].value = '';
    age_inputs[1].value = '';
    age_inputs[2].value = '';   
});

$(d).on('click','.js-langue-switcher', function(){
  lang_choice_popup.classList.remove('d-none');
  age_confirmation_popup.classList.add('d-none');
});

$(d).on('click','#close-lang-choice', function(e){
  e.preventDefault();
  lang_choice_popup.classList.add('d-none');
  age_confirmation_popup.classList.remove('d-none');
});

$(d).on('click','.js-country-redirection', function(){
  var close_lang = d.querySelector("#close-lang-choice");
  var store = this.getAttribute('data-store');
  var data_prev_store = ageform.getAttribute("data-prev-store");
  var prev_store = checkPreviewStore(data_prev_store);

  this.setAttribute("data-store", store);
  ageform.setAttribute("data-store", store);
  ageform.setAttribute("data-prev-store", store);
  
  $('.langue-section .flag-section.'+prev_store.toLocaleLowerCase()).addClass('d-none');
  showCountryFlag(store);
  close_lang.click();
 
});

/*start age confirmation page here */
age_inputs[0].addEventListener('keyup', (event) => {
  var data_store = ageform.getAttribute("data-store");
    if(event.target.value.length > 1) {
      if(data_store == "US"){
        if(age_inputs[1].value.length > 1 && age_inputs[2].value.length > 3){
          calculate(event.target.value +'/'+age_inputs[1].value+'/'+age_inputs[2].value, data_store);
        }
        age_inputs[1].focus();
      }
      else{
        calculate(1);
      }      
    }
    if(data_store == "US"){
      if(event.keyCode == 39) {
        age_inputs[1].focus();
      }
      if(event.target.value > 12) {
        event.target.value = 12;
      }
      if(event.target.value === '00') {
        event.target.value = '01';
      }
    }
})
age_inputs[1].addEventListener('keyup', (event) => {
  var data_store = ageform.getAttribute("data-store");
    if(event.target.value.length > 1) {
      if(data_store == "US"){
        if(age_inputs[0].value.length > 1 && age_inputs[2].value.length > 3){
          calculate(age_inputs[0].value +'/'+event.target.value+'/'+age_inputs[2].value, data_store);
        }
        age_inputs[2].focus();
      }
      else{
        calculate(2);
      }
    }
    if(data_store == "US"){
      if(event.keyCode == 8 && event.target.value.length == 0) {
        age_inputs[0].focus();
      }
      if(event.keyCode == 39) {
        age_inputs[2].focus();
      }
      if(event.keyCode == 37) {
        age_inputs[0].focus();
      }
      if(event.target.value > 31) {
          event.target.value = 31;
      }
      if(event.target.value === '00') {
          event.target.value = '01';
      }
    }
})
age_inputs[2].addEventListener('keyup', (event) => {
  var data_store = ageform.getAttribute("data-store");
    if(event.target.value.length == 4) {
      if(data_store == "US"){
        if(age_inputs[0].value.length > 1 && age_inputs[1].value.length > 1){
          calculate(age_inputs[0].value +'/'+age_inputs[1].value+'/'+event.target.value, data_store);
        }
      }
      else{
        calculate(0);
      }
    }
    if(data_store == "US"){
      if(event.keyCode == 8 && event.target.value.length == 0) {
        age_inputs[1].focus();
      }
      if(event.keyCode == 37) {
        age_inputs[1].focus();
      }
    }
})

  /* end confirmation page here */
  w.addEventListener('load', function () {
    age_inputs[2].setAttribute('max',today.getFullYear());
    age_inputs[2].setAttribute('min',Number(today.getFullYear()) - 200);              
    age_inputs[0].setAttribute('min', 1);
    age_inputs[0].setAttribute('max', 12);
    age_inputs[1].setAttribute('min', 1);
    age_inputs[1].setAttribute('max', 31);
    
    fetch('/browsing_context_suggestions.json')
    .then((resp) => resp.json())
    .then(function(data) {
      var clientCountryLocation = data.detected_values.country.handle;
      showCountryFlag(clientCountryLocation)
      var prev_store = checkPreviewStore(clientCountryLocation);
      ageform.setAttribute("data-store", prev_store)
      ageform.setAttribute("data-prev-store", prev_store)
    })
  });


function checkPreviewStore (country_code){
  var stores = ["FR", "US", "JP"];
  return stores.includes(country_code) ? country_code : "global";
}

function showCountryFlag(country_code){
  age_inputs[0].value = '';
  age_inputs[1].value = '';
  age_inputs[2].value = '';
  if(country_code == "US"){
    mistake_button.classList.add('d-none');
    birtdate_section.classList.remove('d-none');
    age_inputs[0].classList.remove('d-none');            
    age_inputs[1].classList.remove('d-none');            
    age_inputs[2].classList.remove('d-none');
    birtdate_section.classList.add('us-display');
    age_inputs[0].focus();
  }
  else{
    mistake_button.classList.add('d-none');
    birtdate_section.classList.remove('d-none');
    age_inputs[2].classList.remove('d-none');            
    age_inputs[1].classList.add('d-none');            
    age_inputs[0].classList.add('d-none');
    birtdate_section.classList.remove('us-display');
    age_inputs[2].focus();
  }
  // cookie: current_lang
  // 1: international
  // 2: france
  // 3: united kingdom
  // 4: united state
  // 5: japan
  switch (country_code) {
    case "FR":
      $('.langue-section .flag-section.fr').removeClass('d-none');
      cf.setCookie('current_lang', 2, 395);
      convertAgeGateLanguageToFrench();
      break;          
    case "US":
      $('.langue-section .flag-section.us').removeClass('d-none');
      cf.setCookie('current_lang', 4, 395);
      convertAgeGateLanguageToEnglish("US");       
      break;
    case "JP":
      $('.langue-section .flag-section.jp').removeClass('d-none');
      cf.setCookie('current_lang', 5, 395);
      convertAgeGateLanguageToJapanese();
      break; 
    default:
      $('.langue-section .flag-section.global').removeClass('d-none')
      cf.setCookie('current_lang', 1, 395);
      convertAgeGateLanguageToEnglish("INT");
      break;
  }
}

function calculate (input_index, data_store="") {
  var current_lang = Number(cf.getCookie('current_lang'));
  let legal_age = getAgeLimit(current_lang);
  if(data_store == 'US'){
    var birthdate = new Date(input_index);        
    birthdate.setDate(birthdate.getDate() + 1);         
    var ageDifMs = Date.now() - birthdate.getTime();
    var ageDate = new Date(ageDifMs);
    var actualAge = Math.abs(ageDate.getUTCFullYear() - 1970);
    var year_of_birth = new Date().getUTCFullYear() - actualAge;
    if(actualAge >= legal_age){
      confirm(year_of_birth);
    }
    else{
      ageGateProhibited()
    }
  }
  else{
    let current_year = today.getFullYear();
    let current_month = Number(today.getMonth()) + 1;
    let current_day =  Number(today.getDate());            
    let customer_year = Number(age_inputs[2].value);
    switch(input_index) {
      case 1:
        // month              
        if(Number(age_inputs[0].value) < Number(current_month)) {
          confirm(customer_year);
        }
        if(Number(age_inputs[0].value) == Number(current_month)) {
          age_confirmation_title.textContent = age_confirmation_title.getAttribute('data-day-text');
          age_inputs[0].classList.add('d-none');
          age_inputs[1].classList.remove('d-none');
          age_inputs[1].focus();      
        }                  
        if(Number(age_inputs[0].value) > Number(current_month)) {
          ageGateProhibited();
        }
        break;
      case 2:
        // day            
        if(Number(age_inputs[1].value) < Number(current_day)) {
          confirm(customer_year);
        }
        if(Number(age_inputs[1].value) >= Number(current_day)) {
          ageGateProhibited();
        }
        break;
        default:
          // year                           
          let estimated_year = Number(current_year) - Number(legal_age);              
          if(customer_year < Number(estimated_year)) {
            confirm(customer_year);
          }
          if(customer_year == Number(estimated_year)) {
            age_confirmation_title.textContent = age_confirmation_title.getAttribute('data-month-text');
            age_inputs[2].classList.add('d-none');
            age_inputs[0].classList.remove('d-none');
            age_inputs[0].focus();      
          }                  
          if(customer_year > Number(estimated_year)) {
            ageGateProhibited();
          }
    }
  }
}

function confirm(ageyear){
  var customer_age = Number(today.getFullYear()) - Number(ageyear);
  var current_url = window.location.href;
  var staging_env = current_url.includes('staging'); 
  var dev_env = current_url.includes('dev'); 
  var env = "";
  var current_lang = Number(cf.getCookie('current_lang'));

  if(staging_env){
    env += "stg_";
  }
  else if(dev_env){
    env += "dev_";
  }
  else{
    env += "live_";
  }

  if (popup || age_confirmation) {
    var domain = null;
    if(window.location.href.indexOf("dev") == -1 && window.location.href.indexOf("staging") == -1 && window.location.href.indexOf('shopifypreview') == -1 && window.location.href.indexOf('live') == -1 && Shopify.designMode !== true){
      domain = ".champagne-telmont.com";
    }
    cf.setCookie("age_confirmation", "off", 395, domain);
    cf.setCookie("customer_age", customer_age, 395, domain);        
      dataLayer.push({
        'event':'age_gate_validation'
      });

      asyncawaitcookiesconsent();

      if(Shopify.designMode !== true){
      switch(current_lang){
        case 2:
          env += "fr";
          w.location.href = site_url[env]+'?c=FR';
          break;
        case 4:
          env += "us";
          w.location.href = site_url[env]+'?c=US';
          break;
        case 5:
          env += "jp";
          w.location.href = site_url[env]+'?c=JP';
          break;
        default :
          w.location.href +='?c=INT';
          break;
      }
      }
      else{
        window.location.reload();
      }
      
  }
}

function getAgeLimit(current_lang){
  switch(current_lang){
    case 2: 
      return ageLimitsByCountry.fr;
    case 3:
      return ageLimitsByCountry.uk;
    case 4:
      return ageLimitsByCountry.us;
    case 5:
      return ageLimitsByCountry.jp;
    default :
      return ageLimitsByCountry.it;
  }
}

function ageGateProhibited () {
  age_confirmation_title.textContent = age_confirmation_title.getAttribute('data-warning-text');
  mistake_button.classList.remove('d-none');
  age_inputs[0].classList.add('d-none');
  age_inputs[1].classList.add('d-none');
  age_inputs[2].classList.add('d-none');     
  birtdate_section.classList.add('d-none');
}

// can be wrapped for making simple and readable
function isNumeric(num){
  return !isNaN(num)
}

function convertCountrySelectionOptionsToEnglish() {
  d.querySelector(".language-choice .js-country-redirection[data-store='FR'] p").innerHTML = "France<br><small>(French)</small>";
  d.querySelector(".language-choice .js-country-redirection[data-store='INT'] p").innerHTML = "Global website<br><small>(English)</small>";
  d.querySelector(".language-choice .js-country-redirection[data-store='US'] p").innerHTML = "United States<br><small>(English)</small>";
  d.querySelector(".language-choice .js-country-redirection[data-store='JP'] p").innerHTML = "Japan<br><small>(Japanese)</small>";

  d.querySelector(".js-langue-switcher .flag-section.fr .flag-section-right").textContent = "France (French)";
  d.querySelector(".js-langue-switcher .flag-section.global .flag-section-right").textContent = "Global website (English)";
  d.querySelector(".js-langue-switcher .flag-section.us .flag-section-right").textContent = "United State (English)";
  d.querySelector(".js-langue-switcher .flag-section.jp .flag-section-right").textContent = "Japan (Japanese)";
}

function convertCountrySelectionOptionsToJapanese() {
  d.querySelector(".language-choice .js-country-redirection[data-store='FR'] p").innerHTML = "フランス<br><small>(フランス語)</small>";
  d.querySelector(".language-choice .js-country-redirection[data-store='INT'] p").innerHTML = "グローバルサイト<br><small>(英語)</small>";
  d.querySelector(".language-choice .js-country-redirection[data-store='US'] p").innerHTML = "アメリカ<br><small>(英語)</small>";
  d.querySelector(".language-choice .js-country-redirection[data-store='JP'] p").innerHTML = "日本<br><small>(日本語)</small>";

  d.querySelector(".js-langue-switcher .flag-section.fr .flag-section-right").textContent = "フランス (フランス語)";
  d.querySelector(".js-langue-switcher .flag-section.global .flag-section-right").textContent = "グローバルサイト (英語)";
  d.querySelector(".js-langue-switcher .flag-section.us .flag-section-right").textContent = "アメリカ (英語)";
  d.querySelector(".js-langue-switcher .flag-section.jp .flag-section-right").textContent = "日本 (日本語)";
}

function convertCountrySelectionOptionsToFrench() {
  d.querySelector(".language-choice .js-country-redirection[data-store='FR'] p").innerHTML = "France<br><small>(Français)</small>";
  d.querySelector(".language-choice .js-country-redirection[data-store='INT'] p").innerHTML = "Site web Global<br><small>(Anglais)</small>";
  d.querySelector(".language-choice .js-country-redirection[data-store='US'] p").innerHTML = "Etats Unis<br><small>(Anglais)</small>";
  d.querySelector(".language-choice .js-country-redirection[data-store='JP'] p").innerHTML = "Japon<br><small>(Japonais)</small>";

  d.querySelector(".js-langue-switcher .flag-section.fr .flag-section-right").textContent = "France (Français)";
  d.querySelector(".js-langue-switcher .flag-section.global .flag-section-right").textContent = "Site web Global (Anglais)";
  d.querySelector(".js-langue-switcher .flag-section.us .flag-section-right").textContent = "Etats Unis (Anglais)";
  d.querySelector(".js-langue-switcher .flag-section.jp .flag-section-right").textContent = "Japon (Japonais)";
}

function convertAgeGateLanguageToJapanese() {
  var store_link = site_url.live_jp;
  convertCountrySelectionOptionsToJapanese();
  age_confirmation_title.textContent = "生年月日を入力してください";
  age_confirmation_title.setAttribute("data-warning-text", "申し訳ありませんが、あなたはサイトにアクセスするのに十分な年齢ではありません");
  age_confirmation_title.setAttribute("data-year-text", "生年月日を入力してください");
  age_confirmation_title.setAttribute("data-month-text", "生年月日を入力してください");
  age_confirmation_title.setAttribute("data-day-text", "生年月日を入力してください");

  age_gate_rules_message.innerHTML = "当社のサイトにアクセスするには、居住国の法律に従ってアルコールを購入および消費できる法定年齢に達している必要があります。また、<a href='"+store_link+"pages/terms-of-use'>一般利用条件</a>、<a href='"+store_link+"pages/privacy-policy'>プライバシー ポリシー、および Cookie ポリシー</a>。 法的な飲酒年齢がない場合は、21 歳以上である必要があります。";
  age_gate_footer.textContent = "アルコール乱用は健康に危険です。 適度に消費する";

  d.querySelector(".btn-age-verification-div button span").textContent = "私はミスを犯した";
}

function convertAgeGateLanguageToFrench() {
  var store_link = site_url.live_fr;
  convertCountrySelectionOptionsToFrench();
  age_confirmation_title.textContent = "Veuillez entrer votre année de naissance";
  age_confirmation_title.setAttribute("data-warning-text", "Désolé, vous n'êtes pas assez âgé pour accéder au site");
  age_confirmation_title.setAttribute("data-year-text", "Veuillez entrer votre année de naissance");
  age_confirmation_title.setAttribute("data-month-text", "Veuillez entrer votre mois de naissance");
  age_confirmation_title.setAttribute("data-day-text", "Veuillez entrer votre jour de naissance");
  age_gate_rules_message.innerHTML = "Pour visiter notre site, vous devez avoir l'âge légal pour acheter et consommer de l'alcool selon les lois de votre pays de résidence, et aussi vous acceptez nos <a href='"+store_link+"pages/terms-of-use'>conditions générales d’utilisation</a>, notre <a href='"+store_link+"pages/privacy-policy'>politique de confidentialité et notre politique de cookies</a>. S'il n'y a pas d'âge légal pour consommer de l'alcool, vous devez avoir 21 ans ou plus.";
  age_gate_footer.textContent = "L’ABUS D’ALCOOL EST DANGEREUX POUR LA SANTÉ. A CONSOMMER AVEC MODÉRATION";

  d.querySelector(".btn-age-verification-div button span").textContent = "J'ai fait une erreur";
}

function convertAgeGateLanguageToEnglish(country_code) {
  var store_link = country_code.toLocaleLowerCase() == "int" ? "/" : site_url["live_"+country_code.toLocaleLowerCase()];
  var terms_link = country_code.toLocaleLowerCase() == 'us' ? "pages/terms-and-conditions": "pages/terms-of-use";
  convertCountrySelectionOptionsToEnglish();
  age_confirmation_title.textContent = "Please enter your year of birth";
  age_confirmation_title.setAttribute("data-warning-text", "Sorry, you are not old enough to access the site");
  age_confirmation_title.setAttribute("data-year-text", "Please enter your year of birth");
  age_confirmation_title.setAttribute("data-month-text", "Please enter your month of birth");
  age_confirmation_title.setAttribute("data-day-text", "Please enter your day of birth");
  age_gate_rules_message.innerHTML = "To visit our site, you must be of legal age to buy and consume alcohol according to the laws of your country of residence, and also you accept our <a href='"+store_link+terms_link+"'>terms of use</a>, our <a href='"+store_link+"pages/privacy-policy'>privacy policy and our cookies policy</a>. If there is no legal drinking age, you must be 21 or older.";
  age_gate_footer.textContent = "ALCOHOL ABUSE IS DANGEROUS FOR HEALTH. TO CONSUME WITH MODERATION";

  d.querySelector(".btn-age-verification-div button span").textContent = "I Made a mistake";
}
function asyncawaitcookiesconsent(policy) {
  let keeprotateuntil = 0;
  let keeplookingcookiesconsent = setInterval(() => {
      let cookiesbannerfound = document.getElementById('onetrust-banner-sdk'),
          onetrustconsentsdk = document.getElementById('onetrust-consent-sdk');
      if (policy && onetrustconsentsdk) { onetrustconsentsdk.classList.add('policy-page') }
      if(cookiesbannerfound) {
          cookiesbannerfound.style.setProperty('opacity', 1);
          clearInterval(keeplookingcookiesconsent);
          onetrustconsentsdk.style.setProperty('display', "block");
      } else {
          keeprotateuntil++;
          onetrustconsentsdk.style.setProperty('display', "block");
      }
      if(keeprotateuntil > 8) {
          clearInterval(keeplookingcookiesconsent);        
      }
  },100);
  keeplookingcookiesconsent;
}

})($,window,document);
